const elementDescriptions = {
  shellRoot: "Основная оболочка дашборда. Управляет общим фоном и внешними границами.",
  sidebarRoot: "Боковая панель навигации. Содержит ссылки на все страницы и информацию о бренде.",
  sidebarHeader: "Область заголовка боковой панели. Содержит логотип и название компании.",
  sidebarLogo: "Иконка логотипа компании в заголовке боковой панели.",
  sidebarName: "Название компании/бренда в заголовке боковой панели. Редактируемый текст.",
  sidebarNav: "Основная область навигации со ссылками на все вкладки.",
  sidebarNavLink: "Отдельная ссылка навигации в боковой панели. Управляет фоном, цветом и шрифтом.",
  sidebarNavLabel: "Текстовая метка ссылки навигации. Редактируемые название и стиль.",
  sidebarFooter: "Нижняя область боковой панели.",
  sidebarTagline: "Цифровая подпись внизу боковой панели. Редактируемый текст.",
  topbarRoot: "Верхняя панель инструментов с виджетами, поиском и быстрыми действиями.",
  contentMain: "Основная область контента дашборда.",
  pageHeader: "Заголовок страницы с названием и описанием.",
  pageHeaderTitle: "Основной заголовок страницы. Редактируемые текст и шрифт.",
  pageHeaderDescription: "Описание страницы под заголовком. Редактируемый текст.",
  cardProject: "Карточка проекта в списке слоёв. Управляет фоном и границами.",
  cardProjectName: "Название проекта в карточке. Редактируемые текст и шрифт.",
  cardProjectMeta: "Метаданные проекта: слой, статус, источник.",
  badgeHealth: "Индикатор здоровья проекта. Управляет цветами фона и текста.",
} as const;
export default elementDescriptions;
